import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import es from "date-fns/locale/es";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material";

const DeliveryFilters = ({
  user,
  deliveryStatusOptions,
  companies,
  daysOffset,
  isAdmin,
  filters,
  auxSearcher,
  setAuxSearcher,
  handleFilterChange,
  handleDateChange,
  plan,
}) => {
  return (
    <Grid item xs={12} sm className="flex-left filters-container">
      <div className="row-container request-search-container">
        <Grid container>
          <Grid item xs={6} sm="auto" className="input-date-filter">
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={es}
            >
              <DatePicker
                label="Fecha de inicio"
                value={filters.startDate}
                onChange={(newValue) => {
                  let newEndDate = filters.endDate;

                  if (newValue > filters.endDate) {
                    newEndDate = new Date(newValue);
                    newEndDate.setDate(newEndDate.getDate() + daysOffset);
                  }
                  handleDateChange(newValue, newEndDate);
                }}
                className="mg-r-10"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6} sm="auto" className="input-date-filter">
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
            <DatePicker
              label="Fecha de fin"
              value={filters.endDate}
              onChange={(newValue) => {
                let newStartDate = filters.startDate;
                if (newValue < filters.startDate) {
                  newStartDate = new Date(newValue);
                  newStartDate.setDate(newStartDate.getDate() - daysOffset);
                }
                handleDateChange(newStartDate, newValue);
              }}
              disabled={filters.startDate === null}
              className="mg-r-10 mg-l-10"
            />
          </LocalizationProvider>
          </Grid>
          <Grid item xs={6} sm="auto" className="input-service-filter">
            <FormControl fullWidth variant="outlined">
              <InputLabel htmlFor="select-service-filte">
                Estado Delivery
              </InputLabel>
              <Select
                value={filters.statusFilter}
                onChange={(e) => {
                  handleFilterChange("statusFilter", e.target.value);
                }}
                input={<OutlinedInput id="select-status-filter" />}
                IconComponent={() => (
                  <i className="material-icons-outlined">expand_more</i>
                )}
              >
                <MenuItem key={"all"} value={"all"}>
                  Todos
                </MenuItem>
                {deliveryStatusOptions
                  .concat(
                    user.is_staff
                      ? [{ value: "no_tracking", label: "Sin Tracking" }]
                      : [],
                  )
                  .map(({ value, label }, index) => (
                    <MenuItem key={index} value={value}>
                      {label}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>

          {plan?.plan_type == "admin_checkout" && (
            <Grid item xs={6} sm="auto" className="input-service-filter">
              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="select-service-filte">
                  Conductor Asignado
                </InputLabel>
                <Select
                  value={filters.assignedDriverFilter}
                  onChange={(e) => {
                    handleFilterChange("assignedDriverFilter", e.target.value);
                  }}
                  input={<OutlinedInput id="select-assigneddriver-filter" />}
                  IconComponent={() => (
                    <i className="material-icons-outlined">expand_more</i>
                  )}
                >
                  <MenuItem key={"all"} value={"all"}>
                    Todos
                  </MenuItem>
                  <MenuItem key={"assigned"} value={"assigned"}>
                    Tuvo asignado
                  </MenuItem>
                  <MenuItem key={"not_assigned"} value={"not_assigned"}>
                    No tuvo asignado
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}

          {isAdmin && (
            <Grid item xs={6} sm="auto" className="input-service-filter">
              <FormControl fullWidth variant="outlined"
               className="mg-r-10 mg-l-10">
                <InputLabel htmlFor="select-service-filter">Empresa</InputLabel>
                <Select
                  value={filters.companyFilter}
                  onChange={(e) => {
                    handleFilterChange("companyFilter", e.target.value);
                  }}
                  input={<OutlinedInput id="select-status-filter" />}
                  IconComponent={() => (
                    <i className="material-icons-outlined">expand_more</i>
                  )}
                >
                  <MenuItem key={"all"} value={"all"}>
                    Todas
                  </MenuItem>
                  {companies.map(({ id, social_reason }, index) => (
                    <MenuItem key={index} value={id}>
                      {social_reason}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}

          <TextField
            variant="outlined"
            label="Buscar"
            name="search"
            value={auxSearcher}
            onChange={(e) => {
              setAuxSearcher(e.target.value);
            }}
            disabled={false}
          />
        </Grid>
      </div>
    </Grid>
  );
};

export default DeliveryFilters;
